/*
 * Copyright 2025 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export type Integer<T extends number = number> = T & { __integerBrand?: void };
export type Float<T extends number = number> = T & { __floatBrand?: void };
export type Double<T extends number = number> = T & { __doubleBrand?: void };
export type Long<T extends string = string> = T & { __longBrand?: void };
export type Byte<T extends number = number> = T & { __byteBrand?: void };
export type Short<T extends number = number> = T & { _shortBrand?: void };

export type DateISOString<T extends string = string> = T & {
  __dateBrand?: void;
};
export type TimestampISOString<T extends string = string> = T & {
  __timestampBrand?: void;
};
